import { render } from "./dialogPlano.vue?vue&type=template&id=635032fc&scoped=true"
import script from "./dialogPlano.vue?vue&type=script&lang=js"
export * from "./dialogPlano.vue?vue&type=script&lang=js"

import "./dialogPlano.vue?vue&type=style&index=0&id=635032fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635032fc"]])

export default __exports__